import React from "react";
import {
  SiReact,
  SiAmazonaws,
  SiFastapi,
  SiPython,
  SiPostgresql,
  SiNodedotjs,
  SiExpress,
  SiDocker,
  SiNextdotjs,
  SiTypescript,
  SiSupabase,
  SiOpenai,
  SiStreamlit,
  SiOpencv,
  SiPytorch,
  SiMantine,
  SiSqlite,
  SiFastify,
  SiRedis,
  SiFirebase,
  SiExpo,
  SiVite,
  SiGithubactions,
  SiGmail,
} from "react-icons/si";

import {
  FaMicrophone,
  FaVolumeUp,
  FaShieldAlt,
  FaBrain,
  FaDatabase,
  FaEnvelope,
  FaClock,
  FaRunning,
  FaTasks,
  FaUsers,
  FaFileAlt,
  FaLayerGroup,
  FaNetworkWired,
  FaMobileAlt,
  FaLock,
  FaSlidersH,
  FaWallet,
} from "react-icons/fa";

export function ClaudeIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" {...props}>
      <path d="M4.72 17.5l4.63-2.61 1.37 3.72c.33.89 1.37 1.34 2.27.87.82-.43 1.18-1.42.86-2.28l-1.34-3.64 4.63 2.61c.84.47 1.91.2 2.38-.64.48-.84.2-1.91-.64-2.38L14.25 13l3.64-1.34c.86-.32 1.35-1.3.99-2.18-.36-.88-1.37-1.32-2.26-.99l-3.64 1.34 2.61-4.63c.47-.84.2-1.91-.64-2.38-.84-.47-1.91-.2-2.38.64L10 8.08 8.63 4.45c-.32-.86-1.31-1.35-2.19-.99-.88.36-1.32 1.37-.99 2.26l1.34 3.64-4.63-2.61c-.84-.47-1.91-.2-2.38.64-.47.84-.2 1.91.64 2.38L5.05 12.38 1.41 13.72c-.86.32-1.35 1.31-.99 2.19.36.88 1.37 1.32 2.26.99l3.64-1.34-2.6 4.63c-.47.84-.2 1.91.64 2.38.84.47 1.91.2 2.38-.64l1.98-3.43z" />
    </svg>
  );
}

export function ChromaIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" {...props}>
      <circle cx="7" cy="7" r="4.5" fill="#E54D2E" />
      <circle cx="17" cy="7" r="4.5" fill="#F76B15" />
      <circle cx="7" cy="17" r="4.5" fill="#3E63DD" />
      <circle cx="17" cy="17" r="4.5" fill="#8E4EC6" />
    </svg>
  );
}

export function OllamaIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" {...props}>
      <path d="M12 2C8.69 2 6 4.69 6 8v3.17c-1.2.91-2 2.36-2 4.01 0 2.76 2.24 5 5 5h6c2.76 0 5-2.24 5-5 0-1.65-.8-3.1-2-4.01V8c0-3.31-2.69-6-6-6zm-3 6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.5 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
    </svg>
  );
}

export const TECH_MAP = {
  react: { Icon: SiReact, label: "React", color: "#61dafb" },
  vite: { Icon: SiVite, label: "Vite", color: "#a855f7" },
  fastapi: { Icon: SiFastapi, label: "FastAPI", color: "#009688" },
  python: { Icon: SiPython, label: "Python", color: "#38bdf8" },
  aws: { Icon: SiAmazonaws, label: "AWS Bedrock", color: "#ff9900" },
  chromadb: { Icon: ChromaIcon, label: "ChromaDB", color: "#c084fc" },
  postgresql: { Icon: SiPostgresql, label: "PostgreSQL", color: "#60a5fa" },
  nodejs: { Icon: SiNodedotjs, label: "Node.js", color: "#68a063" },
  express: { Icon: SiExpress, label: "Express", color: "#e5e7eb" },
  docker: { Icon: SiDocker, label: "Docker", color: "#2496ed" },
  claude: { Icon: ClaudeIcon, label: "Claude", color: "#cc785c" },
  nextjs: { Icon: SiNextdotjs, label: "Next.js", color: "#f3f4f6" },
  typescript: { Icon: SiTypescript, label: "TypeScript", color: "#3178c6" },
  supabase: { Icon: SiSupabase, label: "Supabase", color: "#3ecf8e" },
  openai: { Icon: SiOpenai, label: "OpenAI", color: "#10a37f" },
  streamlit: { Icon: SiStreamlit, label: "Streamlit", color: "#ff4b4b" },
  opencv: { Icon: SiOpencv, label: "OpenCV", color: "#5c8dbc" },
  pytorch: { Icon: SiPytorch, label: "PyTorch", color: "#ee4c2c" },
  mantine: { Icon: SiMantine, label: "Mantine", color: "#339af0" },
  ollama: { Icon: OllamaIcon, label: "Ollama", color: "#f3f4f6" },
  sqlite: { Icon: SiSqlite, label: "SQLite", color: "#38bdf8" },
  fastify: { Icon: SiFastify, label: "Fastify", color: "#f3f4f6" },
  redis: { Icon: SiRedis, label: "Redis", color: "#dc382d" },
  bullmq: { Icon: FaLayerGroup, label: "BullMQ", color: "#f97316" },
  firebase: { Icon: SiFirebase, label: "Firebase", color: "#ffca28" },
  expo: { Icon: SiExpo, label: "Expo", color: "#f3f4f6" },
  githubactions: { Icon: SiGithubactions, label: "GitHub CI", color: "#60a5fa" },
  gmail: { Icon: SiGmail, label: "Gmail API", color: "#ea4335" },
  webspeech: { Icon: FaMicrophone, label: "Web Speech", color: "#60a5fa" },
  speechsynthesis: { Icon: FaVolumeUp, label: "Audio TTS", color: "#c084fc" },
  guardrails: { Icon: FaShieldAlt, label: "Safety Guard", color: "#34d399" },
  auth: { Icon: FaShieldAlt, label: "Auth Guard", color: "#38bdf8" },
  privacy: { Icon: FaLock, label: "Privacy Guard", color: "#fbbf24" },
  rag: { Icon: FaDatabase, label: "SmartRAG", color: "#a78bfa" },
  brain: { Icon: FaBrain, label: "3D Kinematics", color: "#f472b6" },
  websocket: { Icon: FaNetworkWired, label: "WebSocket", color: "#38bdf8" },
  attendance: { Icon: FaClock, label: "Kiosk & Ops", color: "#f59e0b" },
  users: { Icon: FaUsers, label: "Ops Handoff", color: "#f472b6" },
  activity: { Icon: FaRunning, label: "Biomechanics", color: "#34d399" },
  filter: { Icon: FaSlidersH, label: "Temporal Filter", color: "#818cf8" },
  export: { Icon: FaFileAlt, label: "Export Engine", color: "#9ca3af" },
  email: { Icon: FaEnvelope, label: "Email / Alerts", color: "#fb7185" },
  mobile: { Icon: FaMobileAlt, label: "Client Cache", color: "#38bdf8" },
  ledger: { Icon: FaWallet, label: "Settlement", color: "#34d399" },
  audit: { Icon: FaTasks, label: "Audit / Criteria", color: "#34d399" },
};

/**
 * Resolves the tech badge info for a node based on its explicit `tech` property,
 * or heuristically by inspecting title, sub, and tier label.
 */
export function getTechInfo(node, tierLabel = "") {
  if (node.tech && TECH_MAP[node.tech]) {
    return TECH_MAP[node.tech];
  }

  const text = `${node.title || ""} ${node.sub || ""} ${tierLabel}`.toLowerCase();

  if (text.includes("fastapi")) return TECH_MAP.fastapi;
  if (text.includes("chromadb") || text.includes("chroma")) return TECH_MAP.chromadb;
  if (text.includes("bedrock") || text.includes("nova ") || text.includes("amazon bedrock") || text.includes("aws")) return TECH_MAP.aws;
  if (text.includes("web speech") || text.includes("speech api") || text.includes("voice input") || text.includes("mic")) return TECH_MAP.webspeech;
  if (text.includes("speechsynthesis") || text.includes("voice playback") || text.includes("tts")) return TECH_MAP.speechsynthesis;
  if (text.includes("postgresql") || text.includes("postgres") || text.includes("sequelize")) return TECH_MAP.postgresql;
  if (text.includes("docker") || text.includes("github actions")) return TECH_MAP.docker;
  if (text.includes("claude") || text.includes("anthropic")) return TECH_MAP.claude;
  if (text.includes("openai")) return TECH_MAP.openai;
  if (text.includes("supabase")) return TECH_MAP.supabase;
  if (text.includes("next.js") || text.includes("nextjs") || text.includes("app router")) return TECH_MAP.nextjs;
  if (text.includes("typescript")) return TECH_MAP.typescript;
  if (text.includes("streamlit")) return TECH_MAP.streamlit;
  if (text.includes("opencv")) return TECH_MAP.opencv;
  if (text.includes("pytorch") || text.includes("cuda") || text.includes("cpu / gpu")) return TECH_MAP.pytorch;
  if (text.includes("mantine")) return TECH_MAP.mantine;
  if (text.includes("ollama")) return TECH_MAP.ollama;
  if (text.includes("sqlite")) return TECH_MAP.sqlite;
  if (text.includes("fastify")) return TECH_MAP.fastify;
  if (text.includes("redis") || text.includes("bullmq")) return text.includes("bullmq") ? TECH_MAP.bullmq : TECH_MAP.redis;
  if (text.includes("firebase") || text.includes("firestore")) return TECH_MAP.firebase;
  if (text.includes("expo")) return TECH_MAP.expo;
  if (text.includes("vite")) return TECH_MAP.vite;
  if (text.includes("react native") || text.includes("react")) return TECH_MAP.react;
  if (text.includes("node") || text.includes("express")) return text.includes("express") ? TECH_MAP.express : TECH_MAP.nodejs;
  if (text.includes("python")) return TECH_MAP.python;
  if (text.includes("gmail")) return TECH_MAP.gmail;
  if (text.includes("nodemailer") || text.includes("email")) return TECH_MAP.email;
  if (text.includes("safety") || text.includes("guardrail")) return TECH_MAP.guardrails;
  if (text.includes("privacy") || text.includes("anonymiz") || text.includes("zero-cloud")) return TECH_MAP.privacy;
  if (text.includes("websocket")) return TECH_MAP.websocket;
  if (text.includes("attendance") || text.includes("kiosk") || text.includes("clock-in")) return TECH_MAP.attendance;
  if (text.includes("escalat") || text.includes("operator")) return TECH_MAP.users;
  if (text.includes("biomechanic") || text.includes("kinematic")) return TECH_MAP.activity;
  if (text.includes("smoother") || text.includes("filter")) return TECH_MAP.filter;
  if (text.includes("export") || text.includes("format")) return TECH_MAP.export;
  if (text.includes("split") || text.includes("balance") || text.includes("settlement")) return TECH_MAP.ledger;
  if (text.includes("rag") || text.includes("smartrag")) return TECH_MAP.rag;
  if (text.includes("motionbert") || text.includes("3d lifter")) return TECH_MAP.brain;
  if (text.includes("asyncstorage")) return TECH_MAP.mobile;

  return { Icon: SiReact, label: "System Node", color: "var(--project-accent)" };
}

/**
 * Returns an array of relevant tech badges for the tier header.
 */
export function getTierTechBadges(tierLabel = "") {
  const labelLower = tierLabel.toLowerCase();
  const badges = [];

  const addIf = (cond, key) => {
    if (cond && TECH_MAP[key] && !badges.some((b) => b.label === TECH_MAP[key].label)) {
      badges.push(TECH_MAP[key]);
    }
  };

  addIf(labelLower.includes("react native"), "react");
  addIf(labelLower.includes("expo"), "expo");
  addIf(!labelLower.includes("react native") && labelLower.includes("react"), "react");
  addIf(labelLower.includes("vite"), "vite");
  addIf(labelLower.includes("next.js") || labelLower.includes("next"), "nextjs");
  addIf(labelLower.includes("typescript"), "typescript");
  addIf(labelLower.includes("mantine"), "mantine");
  addIf(labelLower.includes("streamlit"), "streamlit");
  addIf(labelLower.includes("python"), "python");
  addIf(labelLower.includes("fastapi"), "fastapi");
  addIf(labelLower.includes("fastify"), "fastify");
  addIf(labelLower.includes("node"), "nodejs");
  addIf(labelLower.includes("express"), "express");
  addIf(labelLower.includes("docker"), "docker");
  addIf(labelLower.includes("bedrock") || labelLower.includes("aws") || labelLower.includes("amazon"), "aws");
  addIf(labelLower.includes("claude"), "claude");
  addIf(labelLower.includes("openai"), "openai");
  addIf(labelLower.includes("supabase"), "supabase");
  addIf(labelLower.includes("firebase"), "firebase");
  addIf(labelLower.includes("redis"), "redis");
  addIf(labelLower.includes("bullmq"), "bullmq");
  addIf(labelLower.includes("opencv"), "opencv");
  addIf(labelLower.includes("pytorch"), "pytorch");
  addIf(labelLower.includes("ollama"), "ollama");
  addIf(labelLower.includes("sqlite"), "sqlite");

  return badges;
}
